import { grommet, Text } from "grommet";
import { deepMerge } from "grommet/utils";
import { ThemeType } from "grommet/themes";
import React from "react";

const ssacovidtheme: ThemeType = {
    global: {
        font: {
            size: "14px",
            family: "Gotham-Book, sans-serif",
        },
        colors: {
            /* BEGIN: Color Palette Definition */
            brand: "var(--accent)",
            "light-1": "#b1b1b1",
            "light-2": "white", //"#e1e1e1",
            "light-3": "#f7f7f7",
            "dark-1": "#0c0e12",
            "dark-2": "#212224bf",
            "dark-3": "#3b3b3b",
            /* END: Color Palette Definition */
            /* BEGIN: Mapping Colors to Grommet Namespaces */
            background: {
                dark: "dark-2",
                light: "light-2",
            },
            "background-back": {
                dark: "dark-1",
                light: "light-1",
            },
            "background-front": {
                dark: "light-3",
                light: "light-3",
            },
            "background-contrast": {
                dark: "light-3",
                light: "dark-3",
            },
            control: {
                dark: "brand",
            },
            "text-muted": {
                dark: "light-3",
                light: "dark-3",
            },
        },
        focus: {
            border: {
                color: "none",
            },
        },
        /* END: Mapping Colors to Grommet Namespaces */
    },
    /* BEGIN: Mapping Colors to Components */
    anchor: {
        color: "text",
        hover: {
            textDecoration: "none",
        },
    },
    button: {
        extend: {
            fontWeight: "bold",
            fontFamily: "Gotham-Bold",
        },
        border: {
            radius: "5px",
            width: "3px",
        },
        color: "background",
    },
    layer: {
        background: {
            dark: "background",
            light: "background",
        },
    },
    heading: {
        weight: 300,
        extend: {
            margin: "0",
        },
    },
    textInput: {
        disabled: {
            opacity: "0.5",
        },
    },
    formField: {
        help: {
            color: "background-contrast",
        },
        disabled: {
            border: {
                color: "background",
            },
            background: {
                color: "transparent",
            },
        },
        round: "4px",
        label: {
            requiredIndicator: (
                <Text a11yTitle="required" color="status-critical">
                    *
                </Text>
            ),
        },
    },
    text: {
        xsmall: { size: "10px" },
        small: { size: "12px" },
        medium: { size: "14px" },
        large: { size: "16px" },
        xlarge: { size: "18px" },
        xxlarge: { size: "20px" },
    },
    paragraph: {
        small: { size: "12px" },
        medium: { size: "14px" },
        large: { size: "16px" },
        xlarge: { size: "18px" },
        xxlarge: { size: "20px" },
    },
    /* END: Mapping Colors to Components */
};

const Theme = deepMerge(grommet, ssacovidtheme);

export default Theme;
